<template>
  <img :src="require('@/assets/images/blog/' + source)" class="flex w-screen" alt="">
</template>

<script>
export default {
  name: "imageElement",
  props: ['source']
}
</script>

<style scoped>

</style>